<template>
  <div class="legal-page">
    <div class="container">
      <h1>服务条款</h1>
      <p class="last-updated">生效日期：2025年10月27日</p>

      <p>欢迎使用深圳灵动帧智能科技有限公司（以下简称“我们”、“本公司”）提供的网站（[您的网站域名]）及相关服务（包括但不限于视频下载、音频处理、图片修复、电子书格式转换、视频换脸、语音克隆等，统称“服务”）。在使用我们的服务前，请您仔细阅读并充分理解本《服务条款》（以下简称“本条款”）。您对服务的使用即表示您已同意并接受本条款的全部内容。如您不同意本条款，请勿使用我们的服务。</p>

      <ol class="terms-list">
        <li>
          <h2>服务内容与使用许可</h2>
          <p>我们向您提供一个在线平台，用于处理您上传的多媒体和文档文件。您可以在遵守本条款的前提下，非独占性地、不可转让地使用我们的服务。您同意仅将服务用于合法目的，不得用于任何违反中国法律法规或侵犯他人权利的行为。</p>
        </li>

        <li>
          <h2>用户账户</h2>
          <p>部分服务可能需要您注册账户。您有责任提供真实、准确、完整的注册信息，并及时更新。您应对您的账户和密码安全负全部责任，并对账户下发生的所有活动承担全部责任。如发现任何未经授权的使用，您应立即通知我们。</p>
        </li>

        <li>
          <h2>用户内容</h2>
          <p>“用户内容”指您通过服务上传、提交或传输的任何文件、数据或信息。</p>
          <ul>
            <li><strong>知识产权：</strong>您声明并保证，您对上传的用户内容拥有合法的版权或使用权，或已获得所有必要的授权。您保留对用户内容的所有权利。您授予我们一项全球性、非独占、免版税、可再许可的许可，以提供、维护和改进服务，包括在服务过程中对内容进行处理、转换和临时存储。</li>
            <li><strong>禁止内容：</strong>您不得上传包含以下内容的用户内容：
              <ul>
                <li>违反中国法律法规或社会主义核心价值观的内容（如反动、色情、暴力、赌博、诈骗等）。</li>
                <li>侵犯他人知识产权、肖像权、隐私权或其他合法权益的内容。</li>
                <li>包含病毒、木马或其他恶意程序的文件。</li>
              </ul>
            </li>
            <li><strong>责任：</strong>您对您上传的用户内容负全部责任。我们不保证用户内容的准确性、完整性或合法性。我们有权在不事先通知的情况下，删除我们认为违反本条款的用户内容，或暂停/终止您的账户。</li>
          </ul>
        </li>

        <li>
          <h2>服务限制与免责声明</h2>
          <p>您理解并同意：</p>
          <ul>
            <li>服务按“现状”和“可用”提供。我们不保证服务的及时性、安全性、无错误或不间断。</li>
            <li>由于技术限制，AI生成的内容（如语音克隆、视频换脸）可能与原始内容存在差异，我们不保证其100%的准确性和自然度。</li>
            <li>文件处理结果可能因源文件质量、格式、编码等因素而异，我们不保证处理后的文件能达到您期望的完美效果。</li>
            <li>我们不对因您使用服务而导致的任何直接、间接、偶然、特殊或后果性损害（包括但不限于数据丢失、利润损失）承担责任，即使我们已被告知该等损害的可能性。</li>
          </ul>
        </li>

        <li>
          <h2>费用与支付</h2>
          <p>我们可能提供免费和付费服务。付费服务的价格、支付方式和退款政策将在服务页面明确说明。您同意按照公布的价格支付费用。所有费用一旦支付，除非另有约定，否则不予退还。</p>
        </li>

        <li>
          <h2>知识产权</h2>
          <p>服务本身（包括网站设计、软件、商标、专利）的所有权利、所有权和利益（包括知识产权）均归我们或我们的许可方所有。本条款不授予您对服务任何部分的任何权利，除非明确授予。</p>
        </li>

        <li>
          <h2>条款的修改</h2>
          <p>我们有权随时修改本条款。修改后的条款将在网站上公布即生效。您继续使用服务即表示您接受修改后的条款。如您不同意修改，请停止使用服务。</p>
        </li>

        <li>
          <h2>终止</h2>
          <p>我们可以随时因任何原因（包括您违反本条款）终止或暂停您对服务的访问。您也可以随时停止使用服务。终止后，您对服务的访问权将立即终止。</p>
        </li>

        <li>
          <h2>适用法律与争议解决</h2>
          <p>本条款的订立、执行和解释均适用中华人民共和国法律。因本条款引起的或与本条款有关的任何争议，双方应首先通过友好协商解决。协商不成的，任何一方均有权将争议提交至我们所在地（深圳市南山区）有管辖权的人民法院诉讼解决。</p>
        </li>

        <li>
          <h2>联系我们</h2>
          <p>如果您对本服务条款有任何问题，请通过以下方式联系我们：</p>
          <ul>
            <li>邮箱：wuyunxiong_cse@163.com</li>
            <li>电话：19872424497</li>
            <li>地址：深圳市南山区粤海街道高新区社区白石路3609深圳湾科技生态园2区9栋514-549</li>
          </ul>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsOfService',
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>

<style scoped>
/* 复用 PrivacyPolicy 的样式 */
.legal-page {
  min-height: 100vh;
  background-color: #f9fafb;
  padding: 40px 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  margin-top: -40px;
}

.container {
  max-width: 900px;
  margin: 0 auto;
  background-color: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.legal-page h1 {
  text-align: center;
  font-size: 2.2rem;
  color: #1a59b1;
  margin-bottom: 10px;
}

.last-updated {
  text-align: center;
  color: #6b7280;
  font-style: italic;
  margin-bottom: 30px;
}

.terms-list {
  counter-reset: item;
  list-style: none;
  padding-left: 0;
}

.terms-list > li {
  margin-bottom: 30px;
  counter-increment: item;
  position: relative;
}

.terms-list > li::before {
  content: counter(item) ".";
  position: absolute;
  left: -40px;
  top: 0;
  font-weight: bold;
  font-size: 1.1rem;
  color: #4f46e5;
  width: 30px;
  text-align: right;
}

.terms-list h2 {
  color: #1f2937;
  margin-bottom: 12px;
  font-size: 1.3rem;
}

.terms-list p, .terms-list li {
  color: #374151;
  margin-bottom: 10px;
  line-height: 1.7;
}

.terms-list ul {
  margin: 10px 0;
  padding-left: 20px;
}

.terms-list ul ul {
  margin-top: 5px;
  margin-bottom: 5px;
}

@media (max-width: 768px) {
  .container {
    padding: 20px;
    margin: 10px;
  }
  .legal-page h1 {
    font-size: 1.8rem;
  }
  .terms-list > li::before {
    left: -30px;
  }
}
</style>
